import styled from "styled-components";

export const Container = styled.footer`
  display: flex;
  flex-direction: row;
  
  justify-content: center;
  align-items: center;
  
  width: 100%;
  height: 10%;
  
  font-size: 16px;
`;
